<template>
    <div class="pet-quote-step select-coverage">
        <quote-step-header
            :title="subStepFields.title"
            :key="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div>
                <app-label>{{ trans(`labels.insurance`) }}</app-label>
                <app-text-radio-buttons
                    class="mb-16"
                    v-model="form[stepName].insurance"
                    :items="items"
                    :break-mobile="true"
                ></app-text-radio-buttons>
            </div>
            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppInput from "../../Forms/Input.vue";
import AppLabel from "../../Forms/Label.vue";

export default {
    name: "PetQuotePetInsurance",
    components: { AppInput, AppLabel },
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            items: [
                {
                    label: this.trans("yes"),
                    value: true
                },
                {
                    label: this.trans("no"),
                    value: false
                }
            ]
        };
    },

    computed: {
        canMoveNext() {
            const { insurance } = this.form[this.stepName];
            return insurance != null;
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-form {
    max-width: $tablet;
    height: auto;
}

.floors {
    display: flex;
    gap: 40px;

    @media (max-width: $tablet) {
        flex-direction: column;
    }

    > div {
        flex: 1;
    }
}

ul {
    list-style: disc;
}
</style>
